"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jsHelpers_1 = require("../../../bridge/jsHelpers");
var nftResolvers_1 = require("../nftResolvers");
var estimateMaxSpendable_1 = __importDefault(require("../estimateMaxSpendable"));
var getTransactionStatus_1 = __importDefault(require("../getTransactionStatus"));
var prepareTransaction_1 = __importDefault(require("../prepareTransaction"));
var createTransaction_1 = __importDefault(require("../createTransaction"));
var updateTransaction_1 = __importDefault(require("../updateTransaction"));
var synchronisation_1 = require("../synchronisation");
var signOperation_1 = require("../signOperation");
var modules_1 = require("../modules");
var postSyncPatch_1 = __importDefault(require("../postSyncPatch"));
var broadcast_1 = __importDefault(require("../broadcast"));
var receive = (0, jsHelpers_1.makeAccountBridgeReceive)();
var scanAccounts = (0, jsHelpers_1.makeScanAccounts)({ getAccountShape: synchronisation_1.getAccountShape });
var sync = (0, jsHelpers_1.makeSync)({
    getAccountShape: synchronisation_1.getAccountShape,
    postSync: postSyncPatch_1["default"],
    shouldMergeOps: false
});
var getPreloadStrategy = function () { return ({
    preloadMaxAge: 30 * 1000
}); };
var currencyBridge = {
    getPreloadStrategy: getPreloadStrategy,
    preload: modules_1.preload,
    hydrate: modules_1.hydrate,
    scanAccounts: scanAccounts,
    nftResolvers: {
        nftMetadata: nftResolvers_1.nftMetadata,
        collectionMetadata: nftResolvers_1.collectionMetadata
    }
};
var accountBridge = {
    createTransaction: createTransaction_1["default"],
    updateTransaction: updateTransaction_1["default"],
    prepareTransaction: prepareTransaction_1["default"],
    estimateMaxSpendable: estimateMaxSpendable_1["default"],
    getTransactionStatus: getTransactionStatus_1["default"],
    sync: sync,
    receive: receive,
    signOperation: signOperation_1.signOperation,
    broadcast: broadcast_1["default"]
};
exports["default"] = {
    currencyBridge: currencyBridge,
    accountBridge: accountBridge
};
//# sourceMappingURL=js.js.map